import { isNil, complement, isEmpty, } from 'ramda';

export const isNotNil = complement(isNil);

export const isNotEmpty = complement(isEmpty);
